<app-route-history
        [driver]="driver"
        [vehicle]="driver.vehicle"
        *ngIf="driver"
></app-route-history>
